import { useContext, useMemo } from 'react'
import { DocPageComment } from '../../types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Typography } from '@mui/material'
import TextEditor from '../texteditor/TextEditor'
import { DocumentationContext } from '../../context/DocumentationContext'

interface DocCommentItemProps {
    comment: DocPageComment,
    idParent?: number
}

interface DocCommentUserOptions {
    label: string,
    color: string,
    action: VoidFunction
}

export default function DocCommentItem({ comment, idParent }: DocCommentItemProps) {
    const context = useContext(DocumentationContext)
    const commentOptions = useMemo(() => {
        if (context?.commentTarget || context?.showCommentEditor) {
            return []
        }
        let optionComment: DocCommentUserOptions = {
            label: 'Comentar',
            action: () => context?.setCommentTarget(comment, 'writing'),
            color: '#555'
        }
        let options: DocCommentUserOptions[] = idParent ? [] : [optionComment]
        if (context?.currentUser === comment.user) {
            options = [
                ...options,
                { label: 'Editar', action: () => context?.setCommentTarget(comment, 'editing'), color: '#555' },
                { label: 'Eliminar', action: () => context?.handleCommentDelete(comment), color: '#555' }
            ]
        }
        return options
    }, [comment, context])
    return (
        <article className='comment' id={String(comment.id)}>
            <div className='comment-user'>
                <Typography variant='body1'><FontAwesomeIcon icon='user' className='comment-user-icon' /> <b>{comment.user || 'Usuario'}</b></Typography>
                <Typography variant='caption'><small>{comment.updatedAt}</small></Typography>
            </div>
            {context?.commentTarget?.action !== 'editing' && <div className='comment-body'>
                <div className='comment-body-content' dangerouslySetInnerHTML={{ __html: `${comment.content}` }} />
            </div>}
            <div className='comment-options'>
                {commentOptions.map((c) => <Button key={c.label} size='small' sx={{ marginRight: '1rem', color: c.color }} onClick={c.action}>
                    <small>{c.label}</small>
                </Button>)}
            </div>
            <div>
                {comment.comments.map(c => <DocCommentItem key={c.id} comment={c} idParent={comment.id} />)}
            </div>
            {context?.commentTarget?.data.id === comment.id && <TextEditor
                onAccept={context.handleCommentSubmit}
                onCancel={context?.handleCommentCancel}
                previousContent={(context.commentTarget.action === 'editing' && context?.commentTarget?.data.content) || ''}
            />}
        </article>
    )
}